import Vue from 'vue'
import App from '../components/App.vue'

// 导入router
import { router } from '../router'

// 导入设备判断
import { device } from '@/assets/js/device'

Vue.config.productionTip = false

Vue.prototype.$device = device

/* eslint-disable no-new */
/* global BUILD_ENV */
console.log(BUILD_ENV)

new Vue({
  el: '#app',
  router,
  render: h => h(App),
  components: { App }
})
